module.exports = __webpack_public_path__ + "static/media/stoneleigh-park-aerial.b459632d.jpg";